import { HttpInterceptorFn } from '@angular/common/http';
import { inject, LOCALE_ID } from '@angular/core';

/**
 * Predicate for intercepting requests - if returns true, request will be intercepted.
 */
export type LocaleInterceptUrlPredicate = (url: string) => boolean;

/**
 * Returns functional variant of KrosLocaleInterceptor.
 * Adds 'Accept-Language' header to requests.
 * @param interceptUrlPredicate
 */
export function localeInterceptorFn(interceptUrlPredicate: LocaleInterceptUrlPredicate): HttpInterceptorFn {
  return (req, next) => {
    const localeId = inject(LOCALE_ID);

    if (!interceptUrlPredicate(req.url)) {
      return next(req);
    }

    const locale = getLocale(localeId);
    const headers = req.headers.set('Accept-Language', locale);
    const localeRequest = req.clone({ headers });

    return next(localeRequest);
  };
}

function getLocale(localeId: string): string {
  if (localeId === 'sk') {
    return 'sk-SK';
  } else if (localeId.startsWith('en-')) {
    return 'en-GB';
  }
  return localeId;
}
